import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";

const API_BASE = getApiBaseUrl();

export const getAiPlans = async (
  token: string,
  options: { hideGlobalLoader?: boolean } = {}
) => {
  return await apiFetch<AiPlan[]>(`${API_BASE}/api/management/ai-plans`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    hideGlobalLoader: options.hideGlobalLoader,
  });
};

export const deleteAiPlan = async (id: number, token: string): Promise<void> => {
  await apiFetch<void>(`${API_BASE}/api/management/ai-plans/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const acceptAiPlan = async (id: number, token: string): Promise<void> => {
  await apiFetch<void>(`${API_BASE}/api/management/ai-plans/${id}/accept`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const createAiPlanTask = async (id: number, token: string): Promise<void> => {
  await apiFetch<void>(`${API_BASE}/api/management/ai-plans/${id}/create-task`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export interface AiPlan {
  id: number;
  category: string;
  title: string;
  description: string;
  plan_detail: string;
  status: string;
  is_accepted: boolean;
}
